import { render } from "./MemberOfTheMonth.vue?vue&type=template&id=9789f464"
import script from "./MemberOfTheMonth.vue?vue&type=script&lang=js"
export * from "./MemberOfTheMonth.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__